import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../slices/authSlice";
import { useGetAreasQuery } from "../slices/userApiSlice";
import { useGetInformationsQuery } from "../slices/informationApiSlice";
import { Spinner, Button, Container, Row, Col, Card } from "react-bootstrap";
import { FaList, FaSearch, FaReceipt, FaUser, FaPeopleCarry, FaClipboard, FaTags, FaPlusCircle, FaLocationArrow, FaSignOutAlt, FaBookOpen } from "react-icons/fa";
import KE from "../assets/KaraikudiEmart.png";

const HomeScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.auth);
  const role = userInfo?.role;

  const isUser = role === "user";
  const isAdmin = role === "admin";
  const isVendor = role === "vendor";
  const isDelivery = role === "delivery";
  console.log("User Info:", userInfo);
console.log("Role:", role);

  const {
    data,
    isLoading: areasLoading,
    isError: areasError,
  } = useGetAreasQuery(undefined, { skip: !isDelivery });

  const areas = data?.areas ?? [];

  const {
    data: informationData,
    isLoading: infoLoading,
    isError: infoError,
  } = useGetInformationsQuery();

  const logoutHandler = () => {
    dispatch(logout());
    navigate("/", { replace: true });
  };

  const GradientButton = ({ title, icon, onClick, variant = "primary" }) => (
    <Button
      onClick={onClick}
      className="d-flex align-items-center justify-content-start mb-3 w-100"
      variant={variant}
    >
      <span className="me-2">{icon}</span>
      {title}
    </Button>
  );

  return (
    <Container className="py-4">
      {/* App Logo */}
      <div className="text-center mb-4">
        <img src={KE} alt="Logo" style={{ width: "200px" }} />
      </div>

      {/* Welcome Message */}
      <div className="text-center mb-4">
        <h4>
          <FaUser className="me-2" />
          Welcome, {role?.toUpperCase()}
        </h4>
      </div>

      {/* Announcements */}
      <Card className="mb-4">
        <Card.Header>🗒️ Announcements</Card.Header>
        <Card.Body>
          {infoLoading ? (
            <Spinner animation="border" />
          ) : infoError ? (
            <p className="text-danger">Failed to load information.</p>
          ) : (
            informationData?.map((item) => (
              <p key={item._id}>
                • {typeof item.information === "string" ? item.information : ""}
              </p>
            ))
          )}
        </Card.Body>
      </Card>

      {/* Role-based Actions */}
      <Row>
        <Col md={8} className="mx-auto">
          {isUser && (
            <>
            <GradientButton
                title="Search and Quick Order"
                icon={<FaBookOpen />}
                onClick={() => navigate("/productCategory")}
              />
              <GradientButton
                title="Create Order"
                icon={<FaList />}
                onClick={() => navigate("/user-categories")}
              />
              
              <GradientButton
                title="Product Search"
                icon={<FaSearch />}
                onClick={() => navigate("/user-product-search")}
              />
              <GradientButton
                title="My Orders"
                icon={<FaReceipt />}
                onClick={() => navigate("/my-orders")}
              />
              <GradientButton
                title="View Profile"
                icon={<FaUser />}
                onClick={() => navigate("/profile")}
                variant="info"
              />
            </>
          )}

          {isAdmin && (
            <>
            <GradientButton
              title="User List"
              icon={<FaPeopleCarry />}
              onClick={() => navigate("/userList")}
              variant="success"
            />
           <GradientButton
                title="Quick Product Reference"
                icon={<FaBookOpen />}
                onClick={() => navigate("/productCategory")}
              />
            </>
            
            
          )}

          {isVendor && (
            <>
            <GradientButton
                title="Create Sales Order"
                icon={<FaClipboard/>}
                onClick={() => navigate("/order")}
                variant="primary"
              />
              <GradientButton
                title="Search and Create Sales Order"
                icon={<FaClipboard/>}
                onClick={() => navigate("/searchorder")}
                variant="primary"
              />
              <GradientButton
                title="My Orders"
                icon={<FaReceipt />}
                onClick={() => navigate("/my-orders")}
              />
              <GradientButton
                title="Sales Order List"
                icon={<FaClipboard/>}
                onClick={() => navigate("/vendorOrdersList")}
                variant="primary"
              />
              <GradientButton
                title="Quick Product Reference"
                icon={<FaBookOpen />}
                onClick={() => navigate("/productCategory")}
              />
              <GradientButton
                title="Pending Orders"
                icon={<FaClipboard />}
                onClick={() => navigate("/PendingOrders")}
                variant="warning"
              />
              <GradientButton
                title="Product List"
                icon={<FaTags />}
                onClick={() => navigate("/productList")}
                variant="secondary"
              />
              <GradientButton
                title="Create Product"
                icon={<FaPlusCircle />}
                onClick={() => navigate("/createProduct")}
                variant="info"
              />
              <GradientButton
                title="GST R1 Report"
                icon={<FaPlusCircle />}
                onClick={() => navigate("/GSTReport")}
                variant="info"
              />
              <GradientButton
                title="Expiry Date Report"
                icon={<FaPlusCircle />}
                onClick={() => navigate("/expiryproductList")}
                variant="info"
              />
              <GradientButton
                title="InActive Products List"
                icon={<FaPlusCircle />}
                onClick={() => navigate("/inActiveProducts")}
                variant="info"
              />
              <GradientButton
                title="View Profile"
                icon={<FaUser />}
                onClick={() => navigate("/profile")}
                variant="primary"
              />
            </>
          )}

          {isDelivery && (
            <>
              <h5 className="mb-3 mt-4">Select Area</h5>
              {areasLoading ? (
                <Spinner animation="border" />
              ) : areasError ? (
                <p className="text-danger">Failed to load areas.</p>
              ) : (
                areas.map((area) => (
                  <GradientButton
                    key={area}
                    title={area}
                    icon={<FaLocationArrow />}
                    onClick={() =>
                      navigate(`/orders-by-area/${area}`)
                    }
                    variant="danger"
                  />
                ))
              )}
            </>
          )}

          <GradientButton
            title="Logout"
            icon={<FaSignOutAlt />}
            onClick={logoutHandler}
            variant="dark"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default HomeScreen;
